const state = {
  isActiveSecret: false
}

const mutations = {
  toggleSecret (state) {
    state.isActiveSecret = !state.isActiveSecret
    setTimeout(() => {
      state.isActiveSecret = state.isActiveSecret ? false : state.isActiveSecret
    }, 7000)
  }
}

export default { state, mutations }



// WEBPACK FOOTER //
// ./src/store/modules/secret.js